import { Text, TextProps } from '@chakra-ui/react';

// `textStyle="body"` дефолтом: `Text` без токена наследует 16px от `body`, и текст, написанный
// человеком, выпадал из шкалы страницы — комментарий был крупнее описания заявки, ради которого
// страницу открывают. Шесть из семи мест использования и так передавали `body` руками.
export const UserText = ({ children, ...props }: TextProps) => (
  <Text textStyle="body" css={{ overflowWrap: 'anywhere', whiteSpace: 'pre-wrap' }} {...props}>
    {children}
  </Text>
);
